import React from "react";
import NeoLoader from "../../../components/Common/NeoLoader";
import { Breadcrumb } from "../../../components/Common";
import { useCompanySettings } from "./hooks/useCompanySettings";
import CompanyForm from "./components/CompanyForm";

const CompanySettingsPage = () => {
    document.title = "Dados da Empresa | NeoApp - Sistema de Gestão";
    
    const { data, loading, saving, actions } = useCompanySettings();

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
                <NeoLoader type="inline" loading={loading} />
            </div>
        );
    }

    return (
        <React.Fragment>
            <div className="d-flex align-items-center justify-content-between mb-3">
                <Breadcrumb title="Dados da Empresa" />
            </div>

            <div className="border-top mb-3"></div>

            <CompanyForm
                initialData={data}
                onSave={actions.handleSubmit}
                isSaving={saving}
            />
        </React.Fragment>
    );
};

export default CompanySettingsPage;
